<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="800"
        :fullscreen="isMobile" persistent scrollable @keydown.esc="chiudi">
        <v-card>
            <v-card-title>{{ form.id ? 'Modifica macchina' : 'Nuova macchina' }}</v-card-title>
            <v-card-text>
                <v-form ref="formMacchina">
                    <div class="text-subtitle-2 text-medium-emphasis mb-2">Informazioni di base</div>
                    <v-row>
                        <v-col cols="12" sm="6"><v-text-field v-model="form.nome" label="Nome macchina"
                                :rules="[v => !!v || 'Campo obbligatorio']" required /></v-col>
                        <v-col cols="6" sm="3"><v-text-field v-model="form.codice" label="Codice interno" /></v-col>
                        <v-col cols="6" sm="3"><v-select v-model="form.stato" :items="statiDisponibili"
                                item-title="label" item-value="value" label="Stato" /></v-col>
                    </v-row>

                    <v-divider class="my-4" />
                    <div class="text-subtitle-2 text-medium-emphasis mb-2">Dettagli tecnici</div>
                    <v-row>
                        <v-col cols="12" sm="4"><v-text-field v-model="form.marca" label="Marca" /></v-col>
                        <v-col cols="12" sm="4"><v-text-field v-model="form.modello" label="Modello" /></v-col>
                        <v-col cols="12" sm="4"><v-text-field v-model="form.numeroSerie"
                                label="Numero di serie / matricola" /></v-col>
                    </v-row>

                    <v-divider class="my-4" />
                    <div class="text-subtitle-2 text-medium-emphasis mb-2">Ubicazione</div>
                    <v-row>
                        <v-col cols="12" sm="6"><v-select v-model="macroAreaId" :items="macroAree" item-title="nome"
                                item-value="id" label="Macro area" clearable
                                @update:model-value="onCambioMacroArea" /></v-col>
                        <v-col cols="12" sm="6"><v-select v-model="form.repartoId" :items="repartiFiltrati"
                                item-title="nome" item-value="id" label="Reparto"
                                :rules="[v => !!v || 'Campo obbligatorio']" required /></v-col>
                    </v-row>

                    <v-divider class="my-4" />
                    <v-row>
                        <v-col cols="12" sm="6">
                            <div class="text-subtitle-2 text-medium-emphasis mb-2">Descrizione</div>
                            <v-textarea v-model="form.descrizione" label="Descrizione" rows="3" />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <div class="text-subtitle-2 text-medium-emphasis mb-2">Note</div>
                            <v-textarea v-model="form.note" label="Note" rows="3" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Annulla</v-btn>
                <v-btn color="primary" :loading="salvataggio" @click="salva">Salva</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { STATI_MACCHINA } from "@/constants/statoMacchina.js";

export default {
    name: "DialogMacchina",

    props: {
        modelValue: { type: Boolean, default: false },
        macchina: { type: Object, default: null },
    },
    emits: ["update:modelValue", "salvato"],

    data() {
        return {
            form: this.formVuoto(),
            macroAreaId: null,
            salvataggio: false,
            statiDisponibili: STATI_MACCHINA,
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        reparti() {
            return this.$store.getters["configurazione/reparti"];
        },
        macroAree() {
            return this.$store.getters["configurazione/macroAree"];
        },
        repartiFiltrati() {
            if (!this.macroAreaId) return this.reparti;
            return this.reparti.filter(r => r.macroAreaId === this.macroAreaId);
        },
    },

    watch: {
        modelValue(val) {
            if (val) this.inizializza();
        },
    },

    methods: {
        formVuoto() {
            return {
                id: null,
                repartoId: null,
                codice: "",
                nome: "",
                marca: "",
                modello: "",
                numeroSerie: "",
                descrizione: "",
                note: "",
                stato: "Attiva",
            };
        },

        async inizializza() {
            this.macroAreaId = null;
            this.form = this.macchina
                ? {
                    id: this.macchina.id,
                    repartoId: this.macchina.repartoId,
                    codice: this.macchina.codice,
                    nome: this.macchina.nome,
                    marca: this.macchina.marca,
                    modello: this.macchina.modello,
                    numeroSerie: this.macchina.numeroSerie,
                    descrizione: this.macchina.descrizione,
                    note: this.macchina.note,
                    stato: this.macchina.stato,
                }
                : this.formVuoto();

            await Promise.all([
                this.$store.dispatch("configurazione/caricaMacroAree"),
                this.$store.dispatch("configurazione/caricaReparti"),
            ]);

            if (this.form.repartoId) {
                const reparto = this.reparti.find(r => r.id === this.form.repartoId);
                this.macroAreaId = reparto ? reparto.macroAreaId : null;
            }
        },

        onCambioMacroArea() {
            this.form.repartoId = null;
        },

        async salva() {
            if (!this.$refs.formMacchina.validate()) return;

            this.salvataggio = true;
            try {
                const { id, ...dati } = this.form;
                await this.$store.dispatch("macchine/salva", { id, dati });
                this.$emit("salvato");
                this.chiudi();
            } catch (error) {
                console.log(error);
            }
            this.salvataggio = false;
        },

        chiudi() {
            this.$emit("update:modelValue", false);
        },
    },
};
</script>
